export enum SignUpStep {
    RegistrationInfo,
    CompanyInfo,
    Countries,
    Areas,
    Confirmation,
}

export enum PasswordRecoveryStep {
    VerificationMethod,
    Confirmation,
    NewPassword,
}
